import {Alert, Typography} from "@mui/material";
import React from "react";
import {noPrep, OptionGroup, PrepOption} from "../PrepMenuOptions";
import {PrepMenu} from "./PrepMenu";
import {useFixer} from "./Fixer";

export function PairOnly(props: {
    value: PrepOption;
    group: OptionGroup;
    onChange(v: Partial<PrepOption>): void;
}) {

    const fix = useFixer({
        value: props.value,
        autoFix,
        onChange: props.onChange,
    });

    const group = props.group;

    const onChange = (v: Partial<PrepOption>) => props.onChange(autoFix(v));
    return (
        <>
            <Typography variant="body2">HW Preps (Pair)</Typography>
            <div style={{height: 8}}/>
            <PrepMenu id="pair-frame" name="Frame"
                      value={props.value}
                      editKey="pairFramePrep" editKeyCustom="pairFramePrepCustomTemplate"
                      editKeyCustomName="pairFramePrepCustomTemplateName"
                      groupKey="pairFramePreps" groupCustomKey="pairFramePrepsCustom"
                      group={group} onChange={onChange}/>
            <div style={{height: 8}}/>
            <PrepMenu id="pair-active-door" name="Active"
                      value={props.value}
                      editKey="pairActiveDoorPrep" editKeyCustom="pairActiveDoorPrepCustomTemplate"
                      editKeyCustomName="pairActiveDoorPrepCustomTemplateName"
                      groupKey="pairActiveDoorPreps" groupCustomKey="pairActiveDoorPrepsCustom"
                      group={group} onChange={onChange}/>
            <div style={{height: 8}}/>
            <PrepMenu id="pair-inactive-door" name="Inactive"
                      value={props.value}
                      editKey="pairInactiveDoorPrep" editKeyCustom="pairInactiveDoorPrepCustomTemplate"
                      editKeyCustomName="pairInactiveDoorPrepCustomTemplateName"
                      groupKey="pairInactiveDoorPreps" groupCustomKey="pairInactiveDoorPrepsCustom"
                      group={group} onChange={onChange}/>
            {(!!group.pairBothActiveDoorPreps || !!group.pairBothActiveDoorPrepsCustom) && <>
                <div style={{height: 8}}/>
                <PrepMenu id="pair-both-active-door" name="Both Active"
                      value={props.value}
                      editKey="pairBothActiveDoorPrep" editKeyCustom="pairBothActiveDoorPrepCustomTemplate"
                      editKeyCustomName="pairBothActiveDoorPrepCustomTemplateName"
                      groupKey="pairBothActiveDoorPreps" groupCustomKey="pairBothActiveDoorPrepsCustom"
                      group={group} onChange={onChange}/>
            </>}

            {fix && <Alert severity="warning" style={{marginTop: 8, marginBottom: 8}}>
                Some background properties need to update. Please save product when you're done.
            </Alert>}
        </>
    )
}

function autoFix(v: Partial<PrepOption>): Partial<PrepOption> {
    return {
        ...v,

        // copy to pair too
        singleFramePrep: noPrep,
        singleFramePrepCustomTemplate: null,
        singleFramePrepCustomTemplateName: null,
    }
};